export const TOOLTIP_BACKGROUND_COLOR = "#7F8487";